<template>
  <v-chart v-if="ready" :options="graph"/>
</template>

<script>

import ECharts from 'vue-echarts'
import 'echarts/lib/chart/treemap'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/tooltip'

export default {
  name: 'tree-map-prod',
  components: {'v-chart': ECharts},
  props: ['data'],
  data() {
    return {
      ready: false,
      graph : {
        tooltip: {
          show: true
        },
        title : {
          text: 'Costos Producción',
          x:'left',
          top:5,
          padding:0
        },
        textStyle: {
          fontFamily: 'Gotham',
          color: '#888'
        },
        legend: {
          show: true,
          data:['Preparación', 'Implantación', 'Protección','Cosecha']
        },
        series: [{
          type: 'treemap',
          width: '100%',
          height: '88%',
          levels: [{},
            {
              itemStyle: {
                borderWidth: 2,
                borderColor: '#ddd'
              }
            }],

          upperLabel: {
            show:true,
            padding:3,
            fontWeight: 'bold',
            color: '#002'
          },
          itemStyle: {
            color:'red'
          },
          breadcrum: {
            show: true
          },
          data: [{
            name: 'Preparación',            // First tree
            value: this.sum('prep'),
            label: {
              show: true,
            },
            tooltip: {
              formatter: '{c} USD/Ha'
            },
            children: [{
              name: 'Labores',       // First leaf of first tree
              value: this.data['prod_prep_lab'],

            }, {
              name: 'Semillas, cura semillas e inoculantes',       // Second leaf of first tree
              value: this.data['prod_prep_sem']
            },
            {
              name: 'Herbicidas',       // Second leaf of first tree
              value: this.data['prod_prep_herb'],
            },
            {
              name: 'Insecticidas',       // Second leaf of first tree
              value: this.data['prod_prep_ins']
            },
            {
              name: 'Fungicida',       // Second leaf of first tree
              value: this.data['prod_prep_fung']
            },
            {
              name: 'Fertilizante',       // Second leaf of first tree
              value: this.data['prod_prep_fert']
            }]
          }, {
            name: 'Implantación',            // Second tree
            value: this.sum('imp'),
            children: [{
              name: 'Labores',       // First leaf of first tree
              value: this.data['prod_imp_lab']
            }, {
              name: 'Semillas, cura semillas e inoculantes',       // Second leaf of first tree
              value: this.data['prod_imp_sem']
            },
            {
              name: 'Herbicidas',       // Second leaf of first tree
              value: this.data['prod_imp_herb']
            },
            {
              name: 'Insecticidas',       // Second leaf of first tree
              value: this.data['prod_imp_ins']
            },
            {
              name: 'Fungicida',       // Second leaf of first tree
              value: this.data['prod_imp_fung']
            },
            {
              name: 'Fertilizante',       // Second leaf of first tree
              value: this.data['prod_imp_fert']
            }]
          },
          {
            name: 'Protección',            // Second tree
            value: this.sum('prot'),
            children: [{
              name: 'Labores',       // First leaf of first tree
              value: this.data['prod_prot_lab']
            }, {
              name: 'Semillas, cura semillas e inoculantes',       // Second leaf of first tree
              value: this.data['prod_prot_sem']
            },
            {
              name: 'Herbicidas',       // Second leaf of first tree
              value: this.data['prod_prot_herb']
            },
            {
              name: 'Insecticidas',       // Second leaf of first tree
              value: this.data['prod_prot_ins']
            },
            {
              name: 'Fungicida',       // Second leaf of first tree
              value: this.data['prod_prot_fung']
            },
            {
              name: 'Fertilizante',       // Second leaf of first tree
              value: this.data['prod_prot_fert']
            }]
          },
          {
            name: 'Cosecha',            // Second tree
            value: this.sum('cos'),
            children: [{
              name: 'Labores',       // First leaf of first tree
              value: this.data['prod_cos_lab']
            }, {
              name: 'Semillas, cura semillas e inoculantes',       // Second leaf of first tree
              value: this.data['prod_cos_sem']
            },
            {
              name: 'Herbicidas',       // Second leaf of first tree
              value: this.data['prod_cos_herb']
            },
            {
              name: 'Insecticidas',       // Second leaf of first tree
              value: this.data['prod_cos_ins']
            },
            {
              name: 'Fungicida',       // Second leaf of first tree
              value: this.data['prod_cos_fung']
            }]
          }]
        }]
      }

    }
  },
  methods: {
    sum(section) {
      return this.data['prod_'+section+'_lab'] + this.data['prod_'+section+'_sem'] + this.data['prod_'+section+'_herb'] + this.data['prod_'+section+'_ins'] + this.data['prod_'+section+'_fung'];
    }
  },
  mounted() {
    this.$nextTick(function() {
      this.ready = true;
    })

  }
}
</script>
